import React from 'react'

function footer() {
  return (
    <div>
        <div className='footer_container'>
            <div className='footerBody'>
                <span> © 2025 software.piyamanee.com All rights reserved. </span>
            </div>
        </div>
    </div>
  )
}

export default footer